/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray } from './util.js';
import { getFromSession, setInSession } from './session-util.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MDMedia } from './media-data.js';
import { MVMediaMetadata } from './media-data-view.js';
import { MPreviewUtil } from './media-preview-util.js';


export let MVPreview = function($) {

	var m_root = null,		// "media-preview" root node (jquery object)
		m_visible = false,
		m_saved_selection = [],
		m_open_whole_list_cb = null,
		m_prev_deleted_media_id = null,
		m_cur_media_id = null,
		mdp_canvas_cpy=null, mdp_toolbar_cpy=null,
		mdp_canvas=null, mdp_toolbar=null, mdp_info=null, mdp_data=null,
		m_lazy_mdv_initialized = false,
		m_prev2meta_h = 0.5;

	var m_mvdetail_open = null;

	function _lazy_init_mdv( ondone ) {
		if( m_lazy_mdv_initialized ) {
			ondone();
		} else {
			m_lazy_mdv_initialized = true;
			MVMediaMetadata.setupMetadataView( mdp_data, function() {
				$(document).on( 'mjswinresize', $.debounce( 250, function() {
					resize(true,false,$('#mdp-canvas',m_root),$('#mdp-toolbar',m_root),null);
				} ) );
				MDMedia.bindMetaChanged( function mvpreview_on_meta_changed( media_ids, meta, trigger_meta_ids ) {
					if( m_visible && m_cur_media_id!==null && arr_inArray(m_cur_media_id,media_ids)!=-1 ) {
						// update preview...
						switchPreview( m_cur_media_id );
					}
				} );
				MDMedia.bindMediaDeleted( function mvpreview_on_media_deleted( media_ids ) {
					if( m_visible && m_cur_media_id!==null && arr_inArray(m_cur_media_id,media_ids)!=-1 ) {
						// update preview...
						m_prev_deleted_media_id = m_cur_media_id;
						m_cur_media_id = null;
						resetPreview();
					}
				} );
				MDMedia.bindMediaRestored( function mvpreview_on_media_restored( media_ids, data ) {
					// console.log({w:'PREVIEW bindMediaRestored',media_ids,data});
					if( m_visible && m_cur_media_id===null && m_prev_deleted_media_id!==null && arr_inArray(m_prev_deleted_media_id,media_ids)!=-1 ) {
						// update preview...
						m_cur_media_id = m_prev_deleted_media_id;
						m_prev_deleted_media_id = null;
						resetPreview();
					}
				} );
				mdp_info.resizable( {
					handles:	'n',
					minHeight:	2,
					resize:		function(evt,ui) {
						resize(false,true,$('#mdp-canvas',m_root),$('#mdp-toolbar',m_root),null);
					},
					stop:		function(evt,ui) {
						resize( true,true,$('#mdp-canvas',m_root),$('#mdp-toolbar',m_root),null);
					},
				} );
				ondone();
			}, 'preview_' );
		}
	}

	function resize( stop, by_mouse, canvas, toolbar, setup_preview ) {

		//console.log([ 'resize->do', m_visible, m_cur_media_id, stop, by_mouse, canvas, toolbar, setup_preview ]);

		var min_canvas_h = 50,
			tb_h = 40,
			preview_h = Math.max( min_canvas_h+tb_h+2, m_root.innerHeight()-tb_h-2 ),
			canvas_h = 0,
			data_h = 0;
		if( by_mouse ) {
			mdp_info.css('display','block'); // <-- we need position of this element!
			canvas_h = Math.max( min_canvas_h, mdp_info.position().top-2-tb_h );
			if( canvas_h > preview_h ) canvas_h = preview_h;
			data_h = preview_h - canvas_h;
			if( data_h < 4 ) {
				canvas_h -= 4 - data_h;
				data_h = 4;
			}
			var xi_prev2meta_h = Math.round(100*canvas_h/preview_h);
			if( stop && xi_prev2meta_h!==m_prev2meta_h ) {
				m_prev2meta_h = Math.min(1,Math.max(0,0.01*xi_prev2meta_h));
				setInSession('media_prev2meta_h',xi_prev2meta_h);
			}
		} else {
			canvas_h  =    m_prev2meta_h *preview_h;
			data_h    = (1-m_prev2meta_h)*preview_h;
			if( data_h < 4 ) {
				canvas_h -= 4 - data_h;
				data_h = 4;
			}
		}
		if( m_cur_media_id===null || preview_h<=0 ) {
			// no file selected or space for preview not sufficient
			canvas.hide();
			toolbar.hide();
			mdp_info.css('display','none');
		} else {
			// show & arrange preview items
			var w=m_root.innerWidth()-2-2;
			canvas.css(			{                                 'width':(w  )+'px', 'height':canvas_h+'px'	 					 } ).show();
			toolbar.css(		{ 'top':(canvas_h+1       )+'px', 'width':(w-2)+'px'                        						 } ).show();
			mdp_info.css(		{ 'top':(canvas_h+1+tb_h+1)+'px', 'width':'',         'height':'',				'display':'block'	 } );
			mdp_data.css(		{                                                     'height':(data_h-2)+'px',	'display':'block'    } );
			if( setup_preview ) setup_preview();
			else if( m_visible && stop ) canvas.triggerHandler('mjsresize',[canvas.width(),canvas.height()]);
		}
	}

	function init( root, mvdetail_open_fn ) {
		m_root = root;
		m_mvdetail_open = mvdetail_open_fn || function() { };
		mdp_info = $('#mdp-info',m_root).css('display','none');
		// save templates of nodes...
		mdp_canvas_cpy = $('#mdp-canvas',m_root).detach();
		mdp_toolbar_cpy = $('#mdp-toolbar',m_root).detach();
		// add initial nodes
		m_root.prepend( mdp_toolbar=mdp_toolbar_cpy.clone(false) );
		m_root.prepend( mdp_canvas=mdp_canvas_cpy.clone(false) );
		mdp_toolbar.hide();
		mdp_canvas.hide();//.css('display','none');
		m_prev2meta_h = Math.min(1,Math.max(0,0.01*parseInt(getFromSession('media_prev2meta_h',50),10)));
		// prepare metadata view ...
		mdp_data = $('#mdp-data',m_root);
	}

	function onHide() {
		m_visible = false;
		resetPreview();
		if( mdp_canvas ) mdp_canvas.hide();
		if( mdp_toolbar ) mdp_toolbar.hide();
		mdp_info.css('display','none');
		mdp_data.css('display','none');
	}

	function onResize( make_visible, stopped ) {
		//console.log([ 'MVPreview.onResize', m_cur_media_id, make_visible, stopped, onResize.caller ]);

		if( make_visible ) {
			if( !m_visible ) {
				m_visible = true;
				// set preview to current selection
				if( m_saved_selection.length ) switchPreview( m_saved_selection[0] );
			} else if( m_cur_media_id !== null ) {
				// update preview
				resize( true, false, mdp_canvas, mdp_toolbar, null );
			}
		} else if( m_visible ) {
			resize(stopped,false,$('#mdp-canvas',m_root),$('#mdp-toolbar',m_root),null);
		}
	}

	function resetPreview() {

		//console.log([ 'MVPreview.resetPreview', m_cur_media_id, mdp_canvas, m_visible ]);

		if( mdp_canvas && m_visible ) mdp_canvas.triggerHandler('mjsclose');

		//console.log([ 'MVPreview.resetPreview AFTER mjsclose', m_cur_media_id, mdp_canvas, m_visible ]);

		if( mdp_canvas ) mdp_canvas.remove();
		if( mdp_toolbar ) mdp_toolbar.remove();
		mdp_info.css('display','none');
		mdp_data.css('display','none');
		// swap nodes ...
		m_root.prepend( mdp_toolbar=mdp_toolbar_cpy.clone(false).hide() );
		m_root.prepend( mdp_canvas=mdp_canvas_cpy.clone(false).hide() );
	}

	function switchPreview( media_id ) {
		//console.log([ 'MVPreview.switchPreview', media_id, switchPreview.caller ]);

		resetPreview();
		_lazy_init_mdv( function() {
			var my_mdp_canvas = mdp_canvas;
			var my_mdp_toolbar = mdp_toolbar;
			var my_open_whole_list_cb = m_open_whole_list_cb;
			MDMedia.queryMediaDetailInfo(
				media_id,
				function( dtinfo ) {
					if( MDMedia.wasRecentlyDeleted(media_id) ) {
						// was deleted in the mean-time
						m_cur_media_id = null;
					} else {
						m_cur_media_id = media_id;
						var _setup_preview = function() {

							// setup new preview on canvas & setup toolbar
							var xopts = {
								enable_save_view_meta: true,
								enable_save_view_session: true,
								view_session_pfx:'mdp_',
								default_pdf_viewer_type:'manja',
							};
							MPreviewUtil.createPreview(dtinfo,my_mdp_canvas[0],xopts,my_mdp_toolbar[0]);

							my_mdp_canvas.triggerHandler('mjsshow');

							// setup meta-data view ...
							MVMediaMetadata.setupMetadataViewData( mdp_data, media_id, dtinfo, true, true, null );

							// add 'open' button to toolbar ...
							$('.buttons',my_mdp_toolbar)
								.html('<div class="mdb-open-i icon" title="'+mjt('ctx-menu-open')+'"></div>')
								.find('.mdb-open-i').click( function(e) {
									m_mvdetail_open([media_id],'detail',0,my_open_whole_list_cb);
								} );
						};
						// call resize() first to ensure correct dimensions of canvas, toolbar & data-view
						resize( true, false, my_mdp_canvas, my_mdp_toolbar, _setup_preview );
					}
				}
			);
		} );
	}

	function onSelectionChanged( sel_media_ids, open_whole_list_cb ) {

		//console.log( "MVPreview.onSelectionChanged()", sel_media_ids, m_visible );

		m_saved_selection = sel_media_ids;
		m_open_whole_list_cb = open_whole_list_cb;
		if( m_visible ) {
			if( m_saved_selection.length ) {
				switchPreview( m_saved_selection[0] );
			} else {
				// m_prev_deleted_media_id = null;
				m_cur_media_id = null;
				resetPreview();
			}
		}
	}

	return {
		init,
		onHide,
		onResize,
		onSelectionChanged,
		isVisible: function() {
			return m_visible;
		},
	};

}(jQuery); // namespace MVPreview
